/** Keep shipped and remotely supplied Persian interface terminology consistent. */
export function normalizePersianZoneText(text: string): string {
  return text.replace(/(سه|پنج|هفت|ده)‌زون/gu, '$1‌ناحیه‌ای').replace(/(^|[^\p{L}\p{N}_\u200c])(زون(?:‌های|های|‌ها|ها)?)(?=$|[^\p{L}\p{N}_])/gu,
    (_match, prefix: string, word: string) => prefix + (word === 'زون' ? 'ناحیه' : 'نواحی'));
}
